export default {
  install (Vue) {
    const reveal = (el, clone, binding) => {
      let inClass = 'fadeInUp'
      let outClass = 'fadeOutDown'

      switch (binding.value) {
        case 'fade':
          inClass = 'fadeIn'
          outClass = 'fadeOut'
          break
        case 'up':
          inClass = 'fadeInDown'
          outClass = 'fadeOutUp'
          break
        case 'left':
          inClass = 'fadeInLeft'
          outClass = 'fadeOutRight'
          el.parentNode.style.overflow = 'hidden'
          break
        case 'right':
          inClass = 'fadeInRight'
          outClass = 'fadeOutLeft'
          el.parentNode.style.overflow = 'hidden'
          break

        default:
          inClass = binding.value
          outClass = binding.value
          break
      }
      if (!binding.value) {
        inClass = 'fadeInUp'
        outClass = 'fadeOutDown'
      }
      const k = 1
      const box = clone.getBoundingClientRect()
      if (box.top < window.innerHeight * k && box.top + box.height > 0) {
        el.classList.toggle(outClass, false)
        el.classList.toggle(inClass, true)
      } else {
        el.classList.toggle(outClass, true)
        el.classList.toggle(inClass, false)
      }
    }
    Vue.directive('scroll-reveal', {
      inserted: function (el, binding) {
        el.classList.add('animated')
        const style = window.getComputedStyle(el)
        const clone = document.createElement('div')
        clone.style.cssText = style.cssText
        clone.style.position = 'absolute'
        clone.style.background = 'none'
        clone.style.border = 'none'
        clone.style.boxShadow = 'none'
        clone.style.textShadow = 'none'
        el.parentNode.insertBefore(clone, el)

        const f = function () {
          if (reveal(el, clone, binding)) {
            window.removeEventListener('scroll', f)
          }
        }
        window.addEventListener('scroll', f)
      }
    })
  }
}
